import { bbox } from "@turf/turf";
import { Geometry } from "geojson";
import { MapRef } from "react-map-gl/maplibre";
import { GeoJSONFeatureCollection } from "../clip/clip-ui/models";

const zoomToFeatureCollection = (mapRef: React.Ref<MapRef>, fc: GeoJSONFeatureCollection, padding = 200) => {
  if(fc.features.length === 0){
    return
  }
  const [minLng, minLat, maxLng, maxLat] = bbox(fc);
  // @ts-ignore
  mapRef.current?.fitBounds(
    [
      [minLng, minLat],
      [maxLng, maxLat],
    ],
    { padding, duration: 1000 }
  );
}


const zoomToFeature = (mapRef: React.Ref<MapRef>, geometry: Geometry, padding = 200) =>{
    const [minLng, minLat, maxLng, maxLat] = bbox(geometry);

    // @ts-ignore
    mapRef.current?.fitBounds(
      [
        [minLng, minLat],
        [maxLng, maxLat],
      ],
      { padding, duration: 1000 }
    );
  }

export { zoomToFeature, zoomToFeatureCollection };
